module.exports = __webpack_public_path__ + "img/nfc.eab5644f.png";